import React, { memo } from "react";

import { ShowcaseIntro } from "ui/components/Showcase";

import { NEW_PRICE_BASIC_STEP, NEW_PRICE_DETAILS_STEP, NEW_PRICE_EQUIPMENT_STEP, NEW_PRICE_INTRO_TEXTS } from "./consts";
import NewPriceBasicScene from "./scenes/NewPriceBasicScene";
import NewPriceDetailsScene from "./scenes/NewPriceDetailsScene";
import NewPriceEquipmentScene from "./scenes/NewPriceEquipmentScene";
import { NewPriceIntroProps, NewPriceSceneProps } from "./types";

/** Scena za korak izračuna cijene novog vozila. */
const STEP_SCENES: Record<number, React.FC<NewPriceSceneProps>> = {
  [NEW_PRICE_BASIC_STEP]: NewPriceBasicScene,
  [NEW_PRICE_DETAILS_STEP]: NewPriceDetailsScene,
  [NEW_PRICE_EQUIPMENT_STEP]: NewPriceEquipmentScene,
};

/**
 * Lijevi panel izračuna cijene novog vozila: za korak vlastita scena s karticama koje prikazuju
 * upisane podatke, a ispod objašnjenje koraka.
 */
const NewPriceIntro: React.FC<NewPriceIntroProps> = ({ stepCurrent, stepCount, ...sceneProps }) => {
  const stepKey = STEP_SCENES[stepCurrent] ? stepCurrent : NEW_PRICE_BASIC_STEP;
  const Scene = STEP_SCENES[stepKey];
  const text = NEW_PRICE_INTRO_TEXTS[stepKey];

  return (
    <ShowcaseIntro
      sceneKey={stepKey}
      title={text.title}
      description={text.description}
      stepCurrent={stepKey}
      stepCount={stepCount}
    >
      <Scene {...sceneProps} />
    </ShowcaseIntro>
  );
};

export default memo(NewPriceIntro);
